<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-4 items-center">
    <div>
      <span *ngIf="!addingApplicant" class="font-semibold">Individual Applicants</span>
      <div *ngIf="newApplicantCreated" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Add</span>
        <span class="font-semibold">Applicant</span>
      </div>
      <div *ngIf="addingApplicant && !newApplicantCreated" class="flex flex-col md:flex-row gap-1">
        <div *ngIf="entityType !== sharedService.individualLicense" class="flex flex-col md:flex-row gap-1">
          <span class="font-semibold">Update</span>
          <span class="font-semibold">Applicant</span>
        </div>
        <div *ngIf="entityType === sharedService.individualLicense" class="flex flex-col md:flex-row gap-1">
          <span class="font-semibold">Review</span>
          <span class="font-semibold">Application</span>
        </div>
      </div>
    </div>

    <div class="gap-2 flex justify-self-end items-center">
      <span *ngIf="applicants.length > 0 && !addingApplicant">Click Entry to Manage</span>

      <div class="flex flex-row gap-2" *ngIf="!addingApplicant">
        <button type="button" mat-button color="primary" (click)="createApplicant()">Add</button>

        <button type="button" mat-button color="primary" (click)="getApplicants(!includeArchived)">
          {{includeArchived? 'HideArchived' : 'Show Archived'}}</button>
      </div>

      <div class="flex flex-row gap-2" *ngIf="addingApplicant">
        <button type="button" mat-button color="primary" (click)="saveApplicant()">Save</button>

        <div class="flex flex-row gap-2" *ngIf="entityType === sharedService.individualLicense">
          <button type="button" mat-button color="primary" (click)="close(true)">Save and Close</button>
          <button type="button" mat-button color="warn" (click)="close(false)">Close</button>
        </div>

        <div class="flex flex-row gap-2" *ngIf="entityType !== sharedService.individualLicense">
          <button type="button" *ngIf="!newApplicantCreated" mat-button color="warn"(click)="archiveApplicant(applicant, !applicant.archived)">
            {{ applicant.archived? 'Un-Archive' : 'Archive' }}
          </button>

          <button type="button" mat-button color="warn" (click)="toggleApplicantForm(false)">Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="!addingApplicant">
    <mat-table [dataSource]="applicantSource" matSort #applicantSort="matSort" aria-describedby="individual applicants" class="mat-elevation-z8">
      <ng-container matColumnDef="legalFirstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">First Name</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">First</span>
          {{ applicant.legalFirstName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="legalLastName">
        <mat-header-cell *matHeaderCellDef>Last Name</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">Last</span>
          <div class="flex flex-col">
            <span>{{ applicant.legalLastName }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">Email</span>
          <div class="flex flex-col">
            <span>{{ applicant.email }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="archived">
        <mat-header-cell *matHeaderCellDef>Archived</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">Archived</span>
          <div class="flex flex-col">
            <span>{{ applicant.archived? 'Yes' : 'No' }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant">
          <div class="flex flex-row justify-start items-center">
            <button type="button" mat-icon-button [color]="applicant.archived? 'primary' : 'warn'" (click)="archiveApplicant(applicant, !applicant.archived)"
                    [matTooltip]="applicant.archived? 'Un-Archive Applicant' : 'Archive Applicant'" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <mat-icon *ngIf="!applicant.archived">archive</mat-icon>
              <mat-icon *ngIf="applicant.archived">unarchive</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="applicantColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: applicantColumns" class="hover:bg-gray-500 hover:bg-opacity-25"
               [ngClass]="row.archived? 'bg-red-100 bg-opacity-25 text-black' : ''"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #applicantPaginator="matPaginator">
    </mat-paginator>
  </div>

  <div *ngIf="addingApplicant">
    <form [formGroup]="applicantForm">
      <div class="flex flex-col md:flex-row gap-2">
        <div class="flex flex-col md:w-1/2">
          <mat-card>
            <mat-card-content>
              <mat-card [style.background]="sharedService.darkMode? '#303030' : ''">
                <mat-card-content>
                  <div class="flex flex-col gap-2">
                    <div class="grid grid-cols-2 items-center">
                      <div>
                        <span class="font-semibold">Legal Name</span>
                      </div>
                    </div>

                    <div class="flex flex-col md:flex-row gap-2 w-full">
                      <mat-form-field class="md:w-1/3">
                        <input matInput placeholder="First" formControlName="legalFirstName">
                        <mat-error *ngIf="applicantForm.get('legalFirstName').invalid">
                          Legal first name is required
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field class="md:w-1/3">
                        <input matInput placeholder="Last" formControlName="legalLastName">
                        <mat-error *ngIf="applicantForm.get('legalLastName').invalid">
                          Legal last name required
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field class="md:w-1/3">
                        <input matInput placeholder="Middle" formControlName="legalMiddleName">
                      </mat-form-field>
                    </div>
                    <span class="font-semibold">Preferred Name</span>
                    <div class="flex flex-col md:flex-row gap-2 w-full">
                      <mat-form-field class="md:w-1/3">
                        <input matInput placeholder="First" formControlName="preferredFirstName">
                      </mat-form-field>

                      <mat-form-field class="md:w-1/3">
                        <input matInput placeholder="Last" formControlName="preferredLastName">
                      </mat-form-field>

                      <mat-form-field class="md:w-1/3">
                        <input matInput placeholder="Middle" formControlName="preferredMiddleName">
                      </mat-form-field>
                    </div>

                    <span class="font-semibold">Prior Names and Aliases</span>
                    <mat-form-field class="w-full">
                      <input matInput placeholder="Alternate Names" formControlName="alternateNames">
                    </mat-form-field>

                    <div class="flex flex-col md:flex-row md:gap-2">
                      <div class="flex flex-col md:w-1/2">
                        <div class="flex flex-row items-center">
                          <span class="font-semibold">SSN</span>
                          <mat-checkbox formControlName="noSsn">
                            <span class="text-wrap">I don't have a social security number</span>
                          </mat-checkbox>
                        </div>

                        <mat-form-field>
                          <input matInput formControlName="ssn" placeholder="111-11-1111" mask="000-00-0000">
                          <mat-error *ngIf="validateSsn()">
                            SSN is Required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:w-1/2">
                        <div class="flex h-10 items-center">
                          <span class="font-semibold">Date of Birth</span>
                        </div>
                        <mat-form-field>
                          <input placeholder="mm/dd/yyyy" formControlName="dob" matInput [matDatepicker]="dob" [max]="sharedService.today"/>
                          <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                          <mat-datepicker #dob>
                            <mat-datepicker-actions>
                              <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                              <button mat-button matDatepickerCancel>Cancel</button>
                            </mat-datepicker-actions>
                          </mat-datepicker>
                          <mat-error *ngIf="applicantForm.get('dob').hasError('required')">
                            Date of birth is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col md:flex-row gap-2">
                      <div class="flex flex-col gap-1 md:w-1/2">
                        <span class="font-semibold">Primary Phone</span>
                        <mat-form-field>
                          <input matInput placeholder="" formControlName="phone" placeholder="(555) 555-5555" mask="(000) 000-0000 000000" [validation]="false">
                          <mat-error *ngIf="applicantForm.get('phone').hasError('required')">
                            A primary phone number is required
                          </mat-error>
                          <mat-error *ngIf="applicantForm.get('phone').hasError('pattern')">
                            Phone should match this format: 999-999-9999 x123456
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col gap-1 md:w-1/2">
                        <span class="font-semibold">Alternate Phone</span>
                        <mat-form-field>
                          <input matInput placeholder="(555) 555-5555" formControlName="alternatePhone" mask="(000) 000-0000 000000" [validation]="false">
                          <mat-error *ngIf="applicantForm.get('alternatePhone').hasError('pattern')">
                            Phone should match this format: 999-999-9999 x1234
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col md:flex-row gap-2">
                      <div class="flex flex-col gap-1 md:w-1/2">
                        <span class="font-semibold">Email</span>
                        <mat-form-field>
                          <input matInput formControlName="email" placeholder="Email">
                          <mat-error *ngIf="applicantForm.get('email').hasError('required')">
                            Please enter an email adress
                          </mat-error>
                          <mat-error *ngIf="applicantForm.get('email').hasError('email')">
                            This doesn't look like a valid email address
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col gap-1 md:w-1/2">

                        <span class="font-semibold">Confirm Email Address</span>
                        <mat-form-field>
                          <input matInput formControlName="confirmEmail" placeholder="Confirm Email">
                          <mat-error *ngIf="validateEmail()">
                            Email does not match
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col md:flex-row gap-2 md:items-center">
                      <div class="flex flex-col gap-1 md:w-1/2">
                        <span class="font-semibold">Preferred Language</span>
                        <mat-form-field>
                          <input matInput placeholder="Language" formControlName="language">
                        </mat-form-field>
                      </div>

                      <mat-checkbox formControlName="oregonResident">
                        <span class="text-wrap">I am an Oregon resident</span>
                      </mat-checkbox>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="flex flex-col md:w-1/2 gap-8">
          <address [entityId]="applicant.id"
                   [entityType]="sharedService.individualApplicant"
                   [statuses]="statuses"></address>

          <residential-history [entityId]="applicant.id"
                               [statuses]="statuses"></residential-history>

          <document [entityId]="applicant.id"
                    [entityType]="sharedService.individualApplicant"
                    [statuses]="statuses"></document>
        </div>
      </div>
    </form>
  </div>
</div>
